// Angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import {
	OidcSecurityService,
	OpenIdConfiguration,
	UserDataResult,
} from 'angular-auth-oidc-client';
// Service
import { AppService } from '../../../service/app.service';
// Model
import { SetSecretConfigData } from '../../../action/state.action';
// State
import { SetUserData, SetLoginMessage, SetIsPublicUser } from '../../../auth/action/auth.action';
import { AppInformationService } from '../../../service/app-info.service';
import { GlobalUtils } from '../../../utils/global.utils';
import { FaroSdkService } from '../../../utils/start-faro.service';

@Component({
	selector: 'cv-invision-authenticate',
	templateUrl: './authenticate.component.html',
	styleUrls: ['./authenticate.component.scss'],
})
export class AuthenticateComponent implements OnInit, OnDestroy {
	private atComponentDestroy = new Subject();
	userData: any;
	public today: number = Date.now();
	// If app is running in an Iframe we are basically hide all class configurations
	public isInsideIframe = GlobalUtils.isInsideIframe();
	userData$: Observable<UserDataResult>;
	configuration: OpenIdConfiguration;
	isAuthenticated = false;

	constructor(
		public oidcSecurityService: OidcSecurityService,
		private appInfo: AppInformationService,
		private appService: AppService,
		private store: Store,
		private router: Router,
		private faroSdkService: FaroSdkService
	) {
	}

	ngOnInit(): void {
		this.oidcSecurityService
			.checkAuth()
			.subscribe(async ({isAuthenticated, accessToken}) => {
				if (isAuthenticated) {
					await this.store.dispatch(new SetUserData(accessToken)).toPromise();
					await this.store.dispatch(new SetIsPublicUser(false));
					this.faroSdkService.setUser(accessToken);
					const rootAPI = this.appService.getSecretConfigAPI();
					if (rootAPI) {
						await this.store.dispatch(
							new SetSecretConfigData(
								this.appInfo.appName,
								rootAPI,
								this.appService.getSecretConfigRoute()
							)
						).toPromise();
					}
					this.store.dispatch(new SetLoginMessage(null));
					this.router.navigate([`/`]);
				}
			}, (error:any) => {
				// When an error happens kick the user to default so the whole process start again
				this.router.navigate([`/`]);
			});
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
